import { render, staticRenderFns } from "./WaiverConfigurationList.vue?vue&type=template&id=73b5b36c&scoped=true"
import script from "./WaiverConfigurationList.vue?vue&type=script&lang=js"
export * from "./WaiverConfigurationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b5b36c",
  null
  
)

export default component.exports